import {
    CategoryQuery as SourceCategoryQuery
} from 'SourceQuery/Category.query';
import { Field } from 'Util/Query';

/** @namespace Elganso/Query/Category/Query */
export class CategoryQuery extends SourceCategoryQuery {
    _getcustomizedAttributesFields() {
        return [
            'extraTitle',
            'extraContent',
            'bannerLink',
            'customCategoryDesign'
        ];
    }

    _getcustomizedAttributesField() {
        return new Field('customizedAttributes')
            .addFieldList(this._getcustomizedAttributesFields());
    }

    _getDefaultFields() {
        return [
            ...super._getDefaultFields(),
            this._getcustomizedAttributesField()
        ];
    }
}

export default new CategoryQuery();
